import { constants } from 'lib_ui-services';

export const _private = {};

export default {
    verb: 'doingUpdate',
    namespace: 'application',
    relation: 'runtime',
    type: 'DynamicFieldEntryRemoved',
    prerequisites: [],
    useCaseIds: [constants.useCaseIds.RFID, constants.useCaseIds.ASSET_TRACKING],
    description:
        'For RFID use case and Update screen, remove all location tier fields if one is removed (location, building, company)',
    //this is the actual logic:
    logic: ensureAllLocationTierFieldsAreRemoved
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").WorkflowStack} WorkflowStack
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   workflowStack: WorkflowStack[];
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
async function ensureAllLocationTierFieldsAreRemoved({ data, dispatch }) {
    const { childHNode, entries } = data;
    // Check if the field is a location tier field
    if (childHNode.foreignNamespace !== 'location') return;
    // Find any other location hNodes already in the entries
    const entriesToRemove = entries.filter(
        entry => entry.foreignNamespace === 'location' && entry.foreignRelation !== childHNode.foreignRelation
    );

    // Inform the DynamicFieldEntry component that these entries should be removed
    entriesToRemove.forEach(entry => {
        dispatch(entry, { verb: 'RemoveDynamicFieldEntry', namespace: 'application', relation: 'runtime' });
    });
}
